export default __webpack_public_path__ + "static/media/photogallery-05.79313dbd.webp";